import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { PeopleRoutingModule } from './people-routing.module';
import { PeopleComponent } from './people.component';
import { PersonListComponent } from './person-list/person-list.component';
import { ProfileDetailComponent } from './person/profile-detail.component';
import { GroupEmailComponent } from './group/group-email.component';
import { HighlightSearch } from '../../shared/highlight.pipe';
import { PeopleService } from '../../services/people.service';
import { FacultyService } from '../../services/faculty.service';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PipeModule } from '../../shared/pipe.module';


@NgModule({
    imports: [
        CommonModule,
        PeopleRoutingModule,
        SharedModule,
        NgbModule,
        ReactiveFormsModule,
        PipeModule.forRoot()       
    ],
    declarations: [
        PeopleComponent,
        PersonListComponent,
        ProfileDetailComponent,
        GroupEmailComponent,
        HighlightSearch      
    ],
    exports: [],
    providers: [
        PeopleService,
        FacultyService
    ]
})
export class PeopleModule { }



